import { ArrowRight } from "lucide-react";
import { useLang } from "../../i18n";
import { CARD_IMAGES, scrollTo } from "../../utils";
import { Reveal, SectionHead } from "./Section";

const Products = () => {
  const { t } = useLang();
  return (
    <section id="produits" className="px-6 lg:px-12 py-20 lg:py-32" data-testid="products-section">
      <SectionHead index="01" overline={t.products.overline} title={t.products.title} desc={t.products.desc} />
      <div className="grid md:grid-cols-2 gap-px bg-[#232733] border border-[#232733] mt-14">
        {t.products.items.map((p, i) => (
          <Reveal key={i} delay={i * 0.08} className="bg-[#0A0B0E]">
            <article className="group h-full flex flex-col" data-testid={`product-card-${i}`}>
              <div className="relative h-60 overflow-hidden border-b border-[#232733]">
                <img
                  src={CARD_IMAGES[i]}
                  alt={p.name}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B0E]/80 to-transparent" />
                {i === 0 && (
                  <span className="absolute top-4 left-4 bg-[#FF4D00] text-white font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-1.5" data-testid="product-badge-top">
                    {t.products.badge}
                  </span>
                )}
                <span className="absolute bottom-4 right-4 font-display text-6xl font-extrabold text-white/10 tracking-tighter">
                  0{i + 1}
                </span>
              </div>
              <div className="p-8 flex flex-col flex-1">
                <h3 className="font-display text-2xl lg:text-3xl font-medium tracking-tighter text-white group-hover:text-[#4D8BFF] transition-colors">
                  {p.name}
                </h3>
                <p className="text-sm text-[#A0AABF] mt-3 leading-relaxed flex-1">{p.desc}</p>
                <div className="flex flex-wrap gap-2 mt-5">
                  {p.specs.map((s, j) => (
                    <span key={j} className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#A0AABF] border border-[#232733] px-3 py-1.5">
                      {s}
                    </span>
                  ))}
                </div>
                <button
                  data-testid={`product-spec-link-${i}`}
                  onClick={() => scrollTo(p.href)}
                  className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[#0055FF] hover:text-[#FF4D00] mt-6 transition-colors w-fit group/l"
                >
                  {t.products.cta}
                  <ArrowRight size={14} className="transition-transform group-hover/l:translate-x-1" />
                </button>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Products;
